export default __webpack_public_path__ + "static/media/htmlc.3f5c7717.png";